const HTTP_STATUS_CODE = {
  TOO_MANY_REQUESTS: 429
}

export default HTTP_STATUS_CODE
